module.exports = __webpack_public_path__ + "img/541-15-plan.6b963f48.jpg";